export default "__VITE_ASSET__D8qszeA8__"